const PRINCIPAL_CLASSES = {
  BUTTON: "rounded-pill font-weight-bold elevation-6 ma-2 ",
  ICON: "rounded-pill font-weight-bold ma-2 ",
  ROUND_BUTTON: "v-btn--fab v-btn--round mx-1 my-1-p ",
  PRIMARY: "btn-primary white--text",
  SECONDARY: "white btn-secondary",
  TERTIARY: "white btn-tertiary"
};

export const STYLE_CLASSES = {
  BASIC_PRIMARY: "rounded-pill " + PRINCIPAL_CLASSES.PRIMARY,
  PRIMARY_BTN: PRINCIPAL_CLASSES.BUTTON + PRINCIPAL_CLASSES.PRIMARY,
  SECONDARY_BTN: PRINCIPAL_CLASSES.BUTTON + PRINCIPAL_CLASSES.SECONDARY,
  TERTIARY_BTN: PRINCIPAL_CLASSES.BUTTON + PRINCIPAL_CLASSES.TERTIARY,
  ROUND_BTN: PRINCIPAL_CLASSES.ROUND_BUTTON,
  PRIMARY_ROUND_BTN: PRINCIPAL_CLASSES.ROUND_BUTTON + PRINCIPAL_CLASSES.PRIMARY,
  BASIC_ROUND_BTN: PRINCIPAL_CLASSES.ROUND_BUTTON,
  ICON_BTN: "v-size--large icon-btn",
  SECONDARY_ROUND_BTN:
    PRINCIPAL_CLASSES.ROUND_BUTTON + PRINCIPAL_CLASSES.SECONDARY,
  TERTIARY_ROUND_BTN:
    PRINCIPAL_CLASSES.ROUND_BUTTON + PRINCIPAL_CLASSES.TERTIARY,
  PRIMARY_ICON: PRINCIPAL_CLASSES.ICON + PRINCIPAL_CLASSES.PRIMARY,
  ROUND_BTN_CLASS: PRINCIPAL_CLASSES.ROUND_BUTTON + PRINCIPAL_CLASSES.PRIMARY,
  TEXT_FIELD: " v-text-field  v-input--dense v-text-field--solo rounded-pill",
  V_SELECTIONS: "flex-nowrap",
  SELECT_MULTIPLE: " v-text-field  v-input--dense v-text-field--solo",
  TEXT_AREA: " v-text-field--rounded v-text-field--solo",
  CARD: "rounded-xl elevation-6 ",
  CARD_2: "rounded-lg elevation-3 ",
  CARD_PADING: "pt-8 pl-9 pr-9",
  SWITCH: "v-input--switch--inset mt-2 v-input--dense",
  V_SHEET: "outlined rounded-lg elevation-1",
  CARD_SECTION: "pa-8",
  CHIP_COLOR: {
    SELECTED: "secondary",
    FILLED: "primary",
    ACCENT: "accent"
  },
  BTN_COLOR_PICKER_DEPLOY: "mr-4 label-btn",
  COL_DFLEX_CENTER: "d-flex justify-center align-center",
  ALIGN_CENTER: "d-flex align-center",
  ROW_GENERAL_DETAIL: "row-general-detail",
  ROW_SUB_GENERAL_DETAIL: "d-flex justify-center align-center",
  MARGIN_EVENT_INFO: "margin-event-info",
  USER_ICON_LINK: "mdi mdi-account",
  DIV_STYLE_EVENTS: "div-style-events",
  CARD_STYLE: "overflow: hidden;",
  LOCAL_TEXT_STYLE: "card-text-ln",
  FONT_WEIGHT: "font-weight",
  TITLE_INTRO: "mb-6 capitalize-text ",
  FORMULA: "margin-bottom: 15px;",
  READ_ONLY: "opacity: 0.8",
  ELEMENT_INACTIVE: "element-voided",
  OUTTER_BORDER_ELEMENT_VOIDED: "warning-out-border",
  WARNING_TEXT_COLOR: "warning-text-color",
  FLEX_NOWRAP: "flex-nowrap",
  CALCULATOR_BTN: "ma-1 " + PRINCIPAL_CLASSES.PRIMARY,
  ROW_FORMS: "row-forms"
};

export const SNACKBAR_STYLE = {
  WARNING: {
    COLOR: "#f7a072",
    ICON: "mdi-alert"
  },
  ERROR: {
    COLOR: "#f39a9d",
    ICON: "mdi-close-circle"
  },
  SUCCESS: {
    COLOR: "#69d1c5",
    ICON: "mdi-check"
  },
  INFO: {
    COLOR: "#9cc4d5",
    ICON: "mdi-information"
  }
};

export const SNACKBAR_DEFAULT_TIMEOUT = {
  TIMEOUT: 5000
};

export const WARNING_TEXT_COLOR = "warning-text-color";
